import * as z from "zod/v4";

export const resendGiftCard = {
  name: "resendGiftCard" as const,
  input: z.object({ returnId: z.string(), giftCardId: z.string().optional() }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
